function hasShipmentReferenceInSupportTicket(supportTicket) {
  return supportTicket.shipmentReference !== undefined;
}

export { hasShipmentReferenceInSupportTicket };
//# sourceMappingURL=AnySupportTicket.js.map
